export enum OccurrenceStatusEnum {
    ToStart = 'TO_START',
    Started = 'STARTED',
    Review = 'REVIEW',
    Canceled = 'CANCELED',
    Completed = 'COMPLETED'
}